import SignTransferModal from './containters/SignTransferModalContainer'

export default SignTransferModal
